import { useSelector } from "react-redux";
import {
  formatDuration,
  formatFrenchDate,
  renderLieuBloc,
} from "../utils/utils";
import TooltipTwyny from "./tooltip";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { create } from "../services/services";
import { useState } from "react"; // Import useState for state management

const Recap = (props) => {
  const { selectedPrestations, currentReservation } = useSelector(
    (state) => state.rendezvous
  );
  

  // console.log({ currentReservation });
  const getPrestations = () => {
    // Priority: Use props if available, else fall back to Redux
    if (props?.prestation?.length) {
      return props.prestation;
    } else if (currentReservation?.prestations_snapshot?.length) {
      return currentReservation.prestations_snapshot;
    }
    return []; // Default empty array
  };

 

  // Calculate totals with 5.5% service fee and 20% VAT
  const calculateTotals = () => {
    const prestations = getPrestations();
    let totalHT = 0;
    let totalTTC = 0;
    let totalTVA = 0;
    const fixedVATRate = 0.2; // 20% VAT for all services

    // Calculate service fee (5.5% of subtotal)
    let serviceFee = 0;
    let serviceFeeTVA = 0;
    let prestationSubtotal = 0;

    if (props?.prestation?.length) {
      // Calculate sum of all prestations
      props.prestation.forEach((presta) => {
        const prestaHT = parseFloat(presta.ht) || 0;
        prestationSubtotal += prestaHT;
        totalTVA += prestaHT * fixedVATRate;
      });

      // Calculate service fee (5.5% of prestation subtotal)
      serviceFee = prestationSubtotal * 0.055;
      serviceFeeTVA = serviceFee * fixedVATRate; // 20% VAT on service fee
    }

    totalHT = parseFloat(prestationSubtotal + serviceFee)?.toFixed(2);
    totalTTC = parseFloat(totalHT) + totalTVA + serviceFeeTVA;
    // console.log(totalTTC,totalHT,totalTVA,serviceFeeTVA)

    return {
      prestationSubtotal, // Subtotal before service fee
      serviceFee,
      totalHT:parseFloat(totalHT), // Subtotal + service fee
      totalTTC,
      tva: totalTVA + serviceFeeTVA,
      prestationTVA: totalTVA,
      serviceFeeTVA,
    };
  };
// console.log('hello')
  const {
    prestationSubtotal,
    serviceFee,
    totalHT,
    totalTTC,
    tva,
    prestationTVA,
    serviceFeeTVA,
  } = calculateTotals();

  return (
    <>
      <div className="card-twy">
        <div className="d-flex justify-content-between ">
          <h3 className="grey500 break-all">{props?.etablissement?.nom}</h3>
          {props?.etablissement?.immediat === 1 && (
            <img src="/images/conf-imm.svg" alt="icon lock" />
          )}
        </div>

        <p className="body grey66 mb-0">
          {props?.etablissement?.activite?.name}
        </p>
        <p className="legend grey66 mt-8 mb-0">
          {props?.etablissement?.adresse_postale} ,{" "}
          {props?.etablissement?.code_postal} {props?.etablissement?.ville}
        </p>
        <span className="reviews grey66 body d-flex align-items-center mt-4 ">
          <img src="/images/star-02.svg" className="mr-8" alt="star icon" />
          {props?.etablissement?.average_rating} (
          {props?.etablissement?.reviews_count || 0} avis)
        </span>

        {props?.prestation && props?.from !== "facturation" && (
          <>
            <span className="twyny-border-bottom"></span>
            <h5 className="bg500 mt-24 mb-0">Détails du prix</h5>
            <div className="mt-8">
              {Array.isArray(props?.prestation) ? (
                props.prestation.map((presta, index) => (
                  <div
                    key={index}
                    className="d-flex justify-content-between mt-8"
                  >
                    <p className="body grey66 mb-0">{presta?.name}</p>
                    <p className="body grey66 mb-0 w-100 text-end">
                      {parseFloat(presta?.ht)?.toFixed(2)} €
                    </p>
                  </div>
                ))
              ) : (
                <div className="d-flex justify-content-between mt-8">
                  <p className="body grey66 mb-0">{props?.prestation?.name}</p>
                  <p className="body grey66 mb-0 w-100 text-end">
                    {parseFloat(props?.prestation?.ttc)?.toFixed(2)} €
                  </p>
                </div>
              )}
            </div>

            {/* Show service fee (5.5%) */}
            <div className="d-flex justify-content-between twyny-border-bottom-16  mt-8">
              <p className="body grey66">
                Frais de service Twyny
               
                <TooltipTwyny
                  children={
                    <img
                      src="/images/information-circle-contained.svg"
                      alt="information icon"
                      className="ml-8"
                    />
                  }
                  className={"left100"}
                  text="Pour tout achat effectué sur Twyny, nous appliquons des frais couvrant notre Protection acheteurs,  incluant notre Politique de remboursement.  Ces frais nous permettent de garantir  le bon fonctionnement de notre plateforme et de continuer  à développer une communauté de confiance."
                />
              </p>
              <p className="body grey66">{parseFloat(serviceFee)?.toFixed(2)} €</p>
            </div>

            <div className="d-flex justify-content-between">
              <p className="body grey500">
                Total <span className="bold500">HT</span>
              </p>
              <p className="body grey500">{parseFloat(totalHT)?.toFixed(2)} €</p>
            </div>

            {/* Show VAT breakdown */}
            {prestationSubtotal > 0 && (
              <div className="d-flex justify-content-between  mt-8">
                <p className="body grey66">TVA (20%)</p>
                <p className="body grey66">
                  {parseFloat(prestationTVA + serviceFeeTVA).toFixed(2)} €
                </p>
              </div>
            )}

            <div className="d-flex justify-content-between  mt-8">
              <h5 className="body grey500">
                <span className="bold500">Total </span>TTC
              </h5>
              <h5 className="body grey500">{parseFloat(totalTTC)?.toFixed(2)} €</h5>
            </div>
          </>
        )}
        {props?.from === "facturation" && (
          <>
            <h4 className="grey500 mt-24">Prestations</h4>
            {currentReservation?.prestations_snapshot?.map((presta) => {
              return (
                <div className="mt-16">
                  <p className="body bold500 grey500">{presta?.name}</p>
                  <div className="d-flex align-items-center flex-wrap mt-4">
                    <span className="body grey66 ">
                      {" "}
                      {formatDuration(
                        parseInt(presta?.nbr_seances) * parseInt(presta?.duree)
                      )}
                    </span>
                    <span className="ellipse mx-8"></span>
                    <span className="body grey66 ">
                      {" "}
                      {presta?.nbr_seances} rendez-vous de{" "}
                      {formatDuration(presta?.duree)}
                    </span>
                    <span className="ellipse mx-8"></span>{" "}
                    <span className="body grey66">
                      {parseFloat(presta?.ttc)?.toFixed(2)} €
                    </span>{" "}
                  </div>{" "}
                </div>
              );
            })}
            <hr />
            <h4 className="grey500 mt-24">Intervention</h4>
            <div className="mt-16">
              {renderLieuBloc({
                lieu_intervention: currentReservation?.lieu_intervention,
                rue:
                  currentReservation?.lieu_intervention == "chezpro"
                    ? `${props?.etablissement?.adresse_postale}, ${props?.etablissement?.code_postal} ${props?.etablissement?.ville}`
                    : currentReservation?.adresse_domicile,
              })}

              {!currentReservation?.equipe_auto_assigned &&
                currentReservation?.equipe && (
                  <>
                    <p className="body bold500 grey500 mt-8">
                      Préférence de salarié
                    </p>
                    <p className="body grey66">
                      {currentReservation?.equipe?.name}
                    </p>
                  </>
                )}
            </div>
            <hr />
            <h4 className="grey500 mt-24 mb-0">Date et heure</h4>
            <p className="body text-gray-500 d-flex align-items-center mt-16">
              {" "}
              {formatFrenchDate(currentReservation?.start_time)}{" "}
              <span className="ellipse mx-8"></span>
              {new Date(currentReservation?.start_time)?.toLocaleTimeString(
                "fr-FR",
                {
                  hour: "2-digit",
                  minute: "2-digit",
                 // timeZone: "Europe/Paris",
                  // hour12: false,
                }
              )}
            </p>
          </>
        )}
        
      </div>
      {props?.from === "facturation" && (
      <>  
      <div className="card-twy mt-24">
          <h5 className="bg500  mb-0">Détails du prix</h5>
          <div className="mt-8">
            {Array.isArray(currentReservation?.prestations_snapshot) ? (
              currentReservation?.prestations_snapshot?.map((presta, index) => (
                <div
                  key={index}
                  className="d-flex justify-content-between mt-8"
                >
                  <p className="body grey66 mb-0">{presta?.name}</p>
                  <p className="body grey66 mb-0 w-100 text-end">
                    {parseFloat(presta?.ht)?.toFixed(2)} €
                  </p>
                </div>
              ))
            ) : (
              <div className="d-flex justify-content-between mt-8">
                <p className="body grey66 mb-0">{props?.prestation?.name}</p>
                <p className="body grey66 mb-0 w-100 text-end">
                  {parseFloat(props?.prestation?.ttc)?.toFixed(2)} €
                </p>
              </div>
            )}
          </div>

          {/* Show service fee (5.5%) */}
          <div className="d-flex justify-content-between twyny-border-bottom-16  mt-8">
            <p className="body grey66">
              Frais de service Twyny
              <TooltipTwyny
                children={
                  <img
                    src="/images/information-circle-contained.svg"
                    alt="information icon"
                    className="ml-8"
                  />
                }
                className="left100"
                text="Pour tout achat effectué sur Twyny, nous appliquons des frais couvrant notre Protection acheteurs,  incluant notre Politique de remboursement.  Ces frais nous permettent de garantir  le bon fonctionnement de notre plateforme et de continuer  à développer une communauté de confiance."
              />
            </p>
            <p className="body grey66">{parseFloat(serviceFee)?.toFixed(2)} €</p>
          </div>

          <div className="d-flex justify-content-between">
            <p className="body grey500">
              Total <span className="legend  grey500">HT</span>
            </p>
            <p className="body grey500">{parseFloat(totalHT)?.toFixed(2)} €</p>
          </div>

          {/* Show VAT breakdown */}
          {prestationSubtotal > 0 && (
            <div className="d-flex justify-content-between  mt-8">
              <p className="body grey66">
                TVA <span className="legend ">(20%)</span>
              </p>
              <p className="body grey66">
                {parseFloat(prestationTVA + serviceFeeTVA).toFixed(2)} €
              </p>
            </div>
          )}

          <div className="d-flex justify-content-between  mt-8">
            <h5 className=" grey500">
              Total <span className="legend grey500">TTC </span>
            </h5>
            <h5 className="body grey500">{parseFloat(totalTTC)?.toFixed(2)} €</h5>
          </div>
      
        </div>
      
        </>
      )}
    </>
  );
};

export default Recap;